import React from "react";
import { FaEye, FaTrash } from "react-icons/fa";

import {
  formatUserDate,
  getAdherentsLabel,
  getRoleInfo,
  getUserCreatedDate,
  getUserName,
} from "../utils/adminUsersUtils";

function UsersMobileList({ users = [], deletingId, onOpen, onDelete }) {
  return (
    <section className="space-y-3 lg:hidden">
      {users.map((user) => {
        const role = getRoleInfo(user.role_id);
        const isDeleting = deletingId === user.id;

        return (
          <article
            key={user.id}
            className="rounded-[1.75rem] border border-slate-200 bg-white p-4 shadow-lg shadow-slate-200/50 dark:border-white/10 dark:bg-slate-900 dark:shadow-black/20"
          >
            <div className="flex items-start justify-between gap-3">
              <div>
                <p className="font-bold text-slate-950 dark:text-white">
                  {getUserName(user)}
                </p>

                <p className="mt-1 text-xs font-semibold text-slate-400">
                  {user.email || "Email non renseigné"}
                </p>
              </div>

              <span
                className={`inline-flex min-h-8 shrink-0 items-center gap-2 rounded-2xl px-3 text-xs font-bold ${role.badge}`}
              >
                <span className={`h-2 w-2 rounded-full ${role.dot}`} />
                {role.shortLabel}
              </span>
            </div>

            <div className="mt-4 rounded-2xl bg-slate-50 p-3 dark:bg-white/[0.04]">
              <p className="text-xs font-bold uppercase tracking-[0.14em] text-slate-400">
                Judoka
              </p>

              <p className="mt-1 text-sm font-semibold leading-6 text-slate-600 dark:text-white/60">
                {getAdherentsLabel(user)}
              </p>
            </div>

            <p className="mt-3 text-xs font-semibold text-slate-400">
              Créé le {formatUserDate(getUserCreatedDate(user))}
            </p>

            <div className="mt-4 grid grid-cols-2 gap-2">
              <button
                type="button"
                onClick={() => onOpen(user)}
                className="inline-flex min-h-11 items-center justify-center gap-2 rounded-2xl bg-blue-700 px-4 py-2 text-xs font-bold text-white transition hover:-translate-y-0.5 hover:bg-blue-800"
              >
                <FaEye />
                Détails
              </button>

              <button
                type="button"
                onClick={() => onDelete(user)}
                disabled={isDeleting}
                className="inline-flex min-h-11 items-center justify-center gap-2 rounded-2xl bg-red-600 px-4 py-2 text-xs font-bold text-white transition hover:-translate-y-0.5 hover:bg-red-700 disabled:cursor-not-allowed disabled:bg-slate-300 disabled:text-slate-500"
              >
                <FaTrash />
                {isDeleting ? "..." : "Supprimer"}
              </button>
            </div>
          </article>
        );
      })}
    </section>
  );
}

export default UsersMobileList;